import type { CallerConnectedStatus } from '@/signalr';
import { IncidentChat } from '@/features/incident-chat';

export type IncidentChatPlaceholderProps = {
  incidentId: string;
  callerConnectedStatus: CallerConnectedStatus;
  incidentHasPhoneNumber: boolean;
  incidentIsReadOnly: boolean;
  hasActiveEedVideo: boolean;
  videoExpanded: boolean;
  onRequestVideoCollapse: () => void;
};

export function IncidentChatPlaceholder(props: IncidentChatPlaceholderProps) {
  return <IncidentChat {...props} />;
}
